const endpoints = {
  getLinks: 'api/v2/users/user-id/refferal/links/',
  getReferrals: 'api/v2/users/user-id/referrals/',
}

export default endpoints
